import { httpInstance } from '../httpInstance';

/**
 * Servicio para obtener todos los métodos de pago
 * @returns Promise con la lista de métodos de pago
 */
export const getPaymentMethodsService = () => {
  return httpInstance.get('/payment-methods');
};

/**
 * Servicio para obtener un método de pago por ID
 * @param id - ID del método de pago
 * @returns Promise con el método de pago
 */
export const getPaymentMethodByIdService = (id: string) => {
  return httpInstance.get(`/payment-methods/${id}`);
};

/**
 * Servicio para crear un nuevo método de pago
 * @param data - Datos del método de pago a crear
 * @returns Promise con el método de pago creado
 */
export const createPaymentMethodService = (data: any) => {
  return httpInstance.post('/payment-methods', data);
};

/**
 * Servicio para actualizar un método de pago existente
 * @param data - Datos del método de pago a actualizar (debe incluir id)
 * @returns Promise con el método de pago actualizado
 */
export const updatePaymentMethodService = (data: any) => {
  const { id, ...payload } = data;
  return httpInstance.put(`/payment-methods/${id}`, payload);
};

/**
 * Servicio para eliminar un método de pago
 * @param id - ID del método de pago a eliminar
 * @returns Promise con la respuesta de eliminación
 */
export const deletePaymentMethodService = (id: string) => {
  return httpInstance.delete(`/payment-methods/${id}`);
};

/**
 * Servicio para cambiar el estado (activo/inactivo) de un método de pago
 * @param id - ID del método de pago
 * @param active - Nuevo estado (true = activo, false = inactivo)
 * @returns Promise con el método de pago actualizado
 */
export const togglePaymentMethodStatusService = (id: string, active: boolean) => {
  return httpInstance.patch(`/payment-methods/${id}/status`, { active });
};
